import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SilkHeader from "../components/SilkHeader";

const Ss=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"/></svg>;
const Ig=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none"/></svg>;
const Li=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"/></svg>;
const Tk=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.43v-7.15a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-.81.07z"/></svg>;
const Yt=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.19a3.02 3.02 0 00-2.12-2.14C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.38.55A3.02 3.02 0 00.5 6.19 31.6 31.6 0 000 12a31.6 31.6 0 00.5 5.81 3.02 3.02 0 002.12 2.14c1.88.55 9.38.55 9.38.55s7.5 0 9.38-.55a3.02 3.02 0 002.12-2.14A31.6 31.6 0 0024 12a31.6 31.6 0 00-.5-5.81zM9.75 15.02V8.98L15.5 12z"/></svg>;
const Sp=()=><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.52 17.34c-.24.36-.66.48-1.02.24-2.82-1.74-6.36-2.1-10.56-1.14-.42.12-.78-.18-.9-.54-.12-.42.18-.78.54-.9 4.56-1.02 8.52-.6 11.7 1.32.42.18.48.66.24 1.02zm1.44-3.3c-.3.42-.84.6-1.26.3-3.24-1.98-8.16-2.58-11.94-1.38-.48.12-.96-.12-1.08-.6s.12-.96.6-1.08c4.38-1.32 9.78-.66 13.5 1.62.36.18.48.78.18 1.14zm.12-3.36C15.24 8.4 8.88 8.16 5.16 9.3c-.6.18-1.14-.18-1.32-.72-.18-.6.18-1.14.72-1.32 4.26-1.26 11.28-1.02 15.72 1.56.54.3.72 1.02.42 1.56-.3.42-.96.6-1.5.3z"/></svg>;

const CURRENT_PAGE = "About";
const NAV=[{label:"Home",href:"/"},{label:"About",href:"/about"},{label:"Fashboard",href:"/fashboard"},{label:"Articles",href:"/articles"},{label:"Podcast",href:"/podcast"},{label:"People",href:"/people"},{label:"Contact",href:"/contact"}];
const SOCIALS=[{icon:<Ss/>,label:"Substack",url:"https://materialtalk.substack.com"},{icon:<Ig/>,label:"Instagram",url:"https://instagram.com/materialtalk"},{icon:<Li/>,label:"LinkedIn",url:"https://linkedin.com/company/materialtalk"},{icon:<Tk/>,label:"TikTok",url:"https://www.tiktok.com/@emmafeldner?_r=1&_t=ZG-95JouNbMETZ"},{icon:<Yt/>,label:"YouTube",url:"https://youtube.com/@materialtalk"},{icon:<Sp/>,label:"Spotify",url:"https://open.spotify.com/show/04fMVuTgkMzrD6cNDZViiN"}];

// ── Page Data ────────────────────────────────────────────────────────────
const ABOUT = {
  headline: "Providing insight and awareness on how the fashion industry is using technology to modernise.",
  image: "/images/AboutAms.png",
  paragraphs: [
    "Material Talk is a fashion tech media platform dedicated to providing insight and awareness on how the fashion industry is using technology to modernise.",
    "This includes digital design and product creation (DPC), artificial intelligence (AI) and data, e-commerce and digital retail, augmented reality (AR) & virtual reality (VR), wearable technology, supply chain and manufacturing tech, circular fashion, retail tech for physical stores, body data and sizing tech, and collaboration and workflow tools.",
    "Launched in early 2025, we’ve quickly built a strong presence in the fashion tech space, connecting with hundreds of founders, innovators, brands, and people wanting to break into the industry.",
    "Material Talk is targeted at fashion industry professionals (including those who aspire to be) who are looking for excellent, human-written editorial, opinion, analysis, and advice.",
    "We cover fashion tech from every angle: through articles, collaborations, news, in-depth reports, our podcast, and partnerships with major fashion industry events.",
    "For businesses, we provide the insights and context needed to adopt new technologies with confidence and make smarter decisions. For individuals, we make the space more accessible, helping people understand where they fit, build the right connections, and take meaningful steps into the fashion tech industry.",
  ],
  founderName: "Emma Feldner-Busztin",
  founderTitle: "Founder & Editor",
};

export default function About() {
  const [hoveredNav, setHoveredNav] = useState(null);
  const [imgLoaded, setImgLoaded] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#0a0a0a", color: "#f5f0eb", fontFamily: "'DM Sans', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400&family=DM+Sans:wght@300;400;500&display=swap" rel="stylesheet" />

      {/* HEADER */}
      <header style={{
            padding: isMobile ? "20px 20px 0" : "20px 40px 0",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgba(199,125,255,0.15)",
            paddingBottom: 16,
          }}>
        <div style={{ flex: 1 }} />
        <div style={{ textAlign: "center" }}>
          <a href="/" style={{ textDecoration: "none" }}>
            <div style={{ fontSize: 10, letterSpacing: "0.4em", color: "#c9a96e", marginBottom: 4, fontWeight: 300 }}>EST. 2025</div>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: isMobile ? 32 : 52, fontWeight: 300, letterSpacing: "0.12em", lineHeight: 1, background: "linear-gradient(180deg, #f5f0eb 0%, #c9a96e 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>MATERIAL TALK</div>
            <div style={{ fontSize: 9, letterSpacing: "0.35em", color: "rgba(201,169,110,0.6)", marginTop: 6, marginBottom: 16 }}>FASHION TECH MARKET INSIGHTS</div>
          </a>
          <nav style={{ display: "flex", gap: isMobile ? 12 : 28, flexWrap: "wrap", justifyContent: "center", borderTop: "1px solid rgba(201,169,110,0.1)", paddingTop: 12 }}>
            {NAV.map((item, i) => (
              <Link key={item.label} to={item.href} onMouseEnter={() => setHoveredNav(i)} onMouseLeave={() => setHoveredNav(null)}
                style={{ color: item.label === CURRENT_PAGE ? "#c9a96e" : hoveredNav === i ? "#c9a96e" : "rgba(245,240,235,0.7)", textDecoration: "none", fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 400, transition: "color 0.3s ease" }}>
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
        <div style={{ flex: 1, display: isMobile ? "flex" : "flex", justifyContent: isMobile ? "center" : "flex-end", paddingTop: 8 }}>
          <div style={{ display: "flex", gap: 16, }}>
            {SOCIALS.map(({icon,label,url}) => (
              <a key={label} href={url} title={label} target="_blank" rel="noopener noreferrer" style={{ color: "rgba(245,240,235,0.5)", transition: "color 0.3s", display: isMobile ? "none" : "flex",}}
                onMouseEnter={e=>e.currentTarget.style.color="#c9a96e"} onMouseLeave={e=>e.currentTarget.style.color="rgba(245,240,235,0.5)"}>{icon}</a>
            ))}
          </div>
        </div>
      </header>

      {/* CONTENT */}
      <main style={{ padding: isMobile ? "24px 20px" : "48px 40px", maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ fontSize: 10, letterSpacing: "0.3em", color: "#c9a96e", marginBottom: 12, fontWeight: 500 }}>ABOUT</div>
        <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: isMobile ? 28 : 42, fontWeight: 300, lineHeight: 1.15, margin: "0 0 48px 0" }}>{ABOUT.headline}</h2>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? 12 : 28,flexWrap: "wrap", alignItems: "start" }}>
          <div>
            {ABOUT.paragraphs.map((p, i) => (
              <p key={i} style={{ fontSize: 15, lineHeight: 1.8, color: "rgba(245,240,235,0.75)", margin: "0 0 24px 0", fontWeight: 300 }}>
                {typeof p === "string" ? p : p.map((seg, j) =>
                  typeof seg === "string" ? seg : (
                    <strong key={j} style={{ fontWeight: 500, color: "#f5f0eb" }}>{seg.text}</strong>
                  )
                )}
              </p>
            ))}
            <div style={{ borderTop: "1px solid rgba(201,169,110,0.15)", paddingTop: 20, marginTop: 32 }}>
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 400, marginBottom: 4 }}>{ABOUT.founderName}</div>
              <div style={{ fontSize: 11, letterSpacing: "0.15em", color: "#c9a96e", fontWeight: 400 }}>{ABOUT.founderTitle}</div>
            </div>
          </div>

              <figure style={{ margin: 0, marginTop: isMobile ? 0 : 0 }}>
                <SilkHeader aspectRatio="3 / 4" background="#0a0a0a" simulationHz={50}>
                  {/* no overlay text — let the silk breathe on its own */}
                </SilkHeader>
                <figcaption style={{
                  fontSize: 12,
                  color: "rgba(245,240,235,0.4)",
                  marginTop: 10,
                  fontStyle: "italic",
                  letterSpacing: "0.03em",
                  textAlign: "center"
                }}>
                </figcaption>
              </figure>

        </div>
      </main>

      {/* FOOTER */}
<footer style={{
  padding: isMobile ? "24px 20px" : "24px 40px",
  borderTop: "1px solid rgba(199,125,255,0.08)",
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: isMobile ? 16 : 0,
}}>
  <div style={{ fontSize: 10, color: "rgba(245,240,235,0.25)", letterSpacing: "0.15em" }}>
    © 2026 MATERIAL TALK. ALL RIGHTS RESERVED.
  </div>
  {isMobile && (
    <div style={{ display: "flex", gap: 16 }}>
      {SOCIALS.map(({icon, label, url}) => (
        <a key={label} href={url} title={label} target="_blank" rel="noopener noreferrer"
          style={{ color: "rgba(245,240,235,0.4)", display: "flex" }}>
          {icon}
        </a>
      ))}
    </div>
  )}
</footer>
    </div>
  );
}
